import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  InputNumber,
  Button,
  Select,
  Row,
  Col,
  Typography,
  message,
} from 'antd';

import { getFieldValue } from '../../../helpers';

import { Spinner } from '../../UI';

import styles from './UserForm.module.css';

const { Title } = Typography;
const { Option } = Select;
const FormItem = Form.Item;

message.config({
  top: 12,
  duration: 3
});

class UserForm extends Component {
  state = {
    profileFields: [],
    profile: [],
  };

  componentDidMount () {
    const data = !!this.props.profile && this.props.profile.data[0];
    let i = 0;
    let profileFields = [];
    for (let key in data) {
      if (key === 'rowId') continue;

      i++;
      profileFields.push({
        _id: i,
        value: data[key],
        ...this.props.profile.fields[0][key],
      });
    }

    this.setState({
      profile: this.props.profile,
      profileFields: profileFields
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      const payload = {
        firstName: values['First Name'],
        lastName: values['Last Name'],
        nickName: values['Nickname'],
        country: values['Country'],
        city: values['City'],
        zipCode: values['Zip Code'],
        address: values['Address'],
        skype: values['Skype'],
        timeZone: values['Time Zone'],
        email: values['E-mail'],
        authTimeout: values['Auth Timeout']
      };

      this.props.setProfile(payload, () => {
        if (!this.props.err.message) {
          this.props.fetchProfile(() => this.success('Settings has been updated'));
        } else {
          this.error(this.props.err.message);
        }
      });
    })
  };

  success = (msg) => {
    message.success(msg);
  };

  error = (msg) => {
    message.error(msg);
  };

  render() {
    const {
      loading,
      timeZones,
      countries,
      form: { getFieldDecorator },
    } = this.props;
    const { profileFields } = this.state;

    let content = <Spinner size="small" />;
    if (!loading) {
      if (!!profileFields && profileFields.length > 0) {
        const formControl = (name, settings, control) => (
          getFieldDecorator(name, {
            ...settings,
          })(control)
        );

        const timeZonesList = timeZones && timeZones.map(timezone => (
          <Option
            key={timezone.rowId}
            value={timezone.time_zone}
          >
            {timezone.time_zone}
          </Option>
        ));

        const countriesList = countries && countries.map(country => (
          <Option
            key={country.rowId}
            value={country.code}
          >
            {country.name}
          </Option>
        ));

        content = (
          <Form className={styles['user-form']}>
            <Row
              type="flex"
              gutter={15}
            >
              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Login"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Login',
                    {
                      rules: [{ required: true, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Login'])
                    },
                    <Input
                      size="large"
                      disabled
                    />
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="E-mail"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'E-mail',
                    {
                      rules: [{ required: true, type: 'email', }],
                      initialValue: getFieldValue(profileFields, ['name', 'E-mail'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Nickname"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Nickname',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Nickname'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Time Zone"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Time Zone',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Time Zone']) ? getFieldValue(profileFields, ['name', 'Time Zone']) : []
                    },
                    <Select size="large">
                      {timeZonesList}
                    </Select>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="First Name"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'First Name',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'First Name'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Last Name"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Last Name',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Last Name'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Country"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Country',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Country']) ?  getFieldValue(profileFields, ['name', 'Country']) : []
                    },
                    <Select size="large">
                      {countriesList}
                    </Select>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="City"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'City',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'City'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Zip Code"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Zip Code',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Zip Code'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Address"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Address',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Address'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Skype"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Skype',
                    {
                      rules: [{ required: false, type: 'string' }],
                      initialValue: getFieldValue(profileFields, ['name', 'Skype'])
                    },
                    <Input size="large"/>
                  )}
                </FormItem>
              </Col>

              <Col
                xs={24}
                sm={12}
                lg={8}
              >
                <FormItem
                  label="Auth Timeout"
                  className="form-item-wrapper"
                >
                  {formControl(
                    'Auth Timeout',
                    {
                      rules: [
                        { required: false, type: 'number' }
                      ],
                      initialValue: parseInt(getFieldValue(profileFields, ['name', 'Auth Timeout']))
                    },
                    <InputNumber min={5} max={4320} size="large"/>
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row
              type="flex"
              style={{ paddingTop: '10px' }}
            >
              <Col lg={12}>
                <Button
                  className={styles.button}
                  ghost
                  type="primary"
                  size="large"
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        );
      }
    }

    return (
      <div>
        <Title level={4}>Settings</Title>
        {content}
      </div>
    );
  }
}

UserForm.propTypes = {
  profile: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  timeZones: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  fetchProfile: PropTypes.func.isRequired,
  setProfile: PropTypes.func.isRequired,
  err: PropTypes.object.isRequired,
};

export default Form.create({})(UserForm);
